import React, { FunctionComponent, useMemo, useState } from 'react'
import { AppThemeContext } from './context/AppThemeContext'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import grey from '@material-ui/core/colors/grey'
import CssBaseline from '@material-ui/core/CssBaseline'

const AppThemeProvider: FunctionComponent = ({ children }) => {
  const [isDark, setIsDark] = useState<boolean>(false)
  const variant = 'outlined'

  const theme = useMemo(() => {
    return createMuiTheme({
      overrides: {
        MuiFormLabel: {
          root: {
            '&$disabled': {
              color: 'lightgrey'
            }
          }
        },
        MuiSelect: {
          root: {
            '&$disabled': {
              border: `1px solid ${grey['50']}`
            }
          },
          selectMenu: {
            whiteSpace: 'pre-wrap'
          }
        },
        MuiMenuItem: {
          root: {
            whiteSpace: 'pre-wrap'
          }
        },
        MuiListItem: {
          gutters: {
            padding: '8px 16px!important'
          }
        }
      },
      props: {
        MuiSelect: {
          variant
        },
        MuiNativeSelect: {
          variant
        },
        MuiInputLabel: {
          variant
        },
        MuiFormControl: {
          variant,
          margin: 'normal'
        },
        MuiTextField: {
          variant,
          margin: 'normal'
        }
      },
      palette: {
        type: isDark ? 'dark' : 'light',
        primary: {
          main: '#546e7a'
        },
        secondary: {
          main: '#ff7043'
        },
        error: {
          main: '#E53935'
        }
      }
    })
  }, [isDark])

  return (
    <AppThemeContext.Provider
      value={{
        isDarkMode: isDark,
        toggleThemeMode: () => setIsDark(!isDark)
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </AppThemeContext.Provider>
  )
}
AppThemeProvider.displayName = 'AppThemeProvider'

export default AppThemeProvider
